var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-tabs",
    { attrs: { "content-class": "mt-3", small: "", fill: "" } },
    [
      _c("b-tab", { attrs: { title: "Images" } }, [
        _c("div", { staticClass: "content-module-cards mt-3" }, [
          _c(
            "div",
            {
              staticClass: "card text-center h-100 hover-card",
              on: { click: _vm.addProductImages },
            },
            [
              _c("div", { staticClass: "card-body" }, [
                _c(
                  "h5",
                  { staticClass: "card-title" },
                  [
                    _c("b-icon", {
                      staticClass: "icon-size",
                      attrs: { icon: "file-earmark-image", scale: "1.5" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "card-text" }, [
                  _vm._v("\n            Product Images\n          "),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "card text-center h-100 hover-card",
              on: { click: _vm.addProductImagePlaceholder },
            },
            [
              _c("div", { staticClass: "card-body" }, [
                _c(
                  "h5",
                  { staticClass: "card-title" },
                  [
                    _c("b-icon", {
                      staticClass: "icon-size",
                      attrs: { icon: "plus-square-dotted", scale: "1.5" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "card-text" }, [
                  _vm._v("\n            Product Placeholder\n          "),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "card text-center h-100 hover-card",
              on: { click: _vm.addProductDimensions },
            },
            [
              _c("div", { staticClass: "card-body" }, [
                _c(
                  "h5",
                  { staticClass: "card-title" },
                  [
                    _c("b-icon", {
                      staticClass: "icon-size",
                      attrs: { icon: "aspect-ratio", scale: "1.5" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "card-text" }, [
                  _vm._v("\n            Product Frame\n          "),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "card text-center h-100 hover-card",
              on: { click: _vm.showSmartObject },
            },
            [
              _c("div", { staticClass: "card-body" }, [
                _c(
                  "h5",
                  { staticClass: "card-title" },
                  [
                    _c("b-icon", {
                      staticClass: "icon-size",
                      attrs: { icon: "images", scale: "1.5" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "card-text" }, [
                  _vm._v("\n            Smart Object\n          "),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "card text-center h-100 hover-card",
              on: { click: _vm.addImage },
            },
            [
              _c("div", { staticClass: "card-body" }, [
                _c(
                  "h5",
                  { staticClass: "card-title" },
                  [
                    _c("b-icon", {
                      staticClass: "icon-size",
                      attrs: { icon: "card-image", scale: "1.5" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "card-text" }, [
                  _vm._v("\n            Add Image\n          "),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "card text-center h-100 hover-card",
              on: {
                click: function ($event) {
                  return _vm.addAdditionalField("Background Theme Image")
                },
              },
            },
            [
              _c("div", { staticClass: "card-body" }, [
                _c(
                  "h5",
                  { staticClass: "card-title" },
                  [
                    _c("b-icon", {
                      staticClass: "icon-size",
                      attrs: { icon: "filter-square", scale: "1.5" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "card-text" }, [
                  _vm._v("\n            Image Placeholder\n          "),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "card text-center h-100 hover-card generate-background",
            },
            [
              _c("div", { staticClass: "card-body" }, [
                _c(
                  "h5",
                  { staticClass: "card-title" },
                  [
                    _c("b-icon", {
                      staticClass: "icon-size",
                      attrs: { icon: "stars", scale: "1.5" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "card-text" }, [
                  _vm._v("\n            Generate Image\n          "),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "card text-center h-100 hover-card translate-image",
              attrs: { "data-id": _vm.selectedInstance.id },
            },
            [
              _c("div", { staticClass: "card-body" }, [
                _c(
                  "h5",
                  { staticClass: "card-title" },
                  [
                    _c("b-icon", {
                      staticClass: "icon-size",
                      attrs: { icon: "translate", scale: "1.5" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "card-text" }, [
                  _vm._v("\n            Translate Image\n          "),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "card text-center h-100 hover-card make-template-editable",
              attrs: { "data-id": _vm.selectedInstance.id },
            },
            [
              _c("div", { staticClass: "card-body" }, [
                _c("h5", { staticClass: "card-title" }, [
                  _c("img", {
                    attrs: {
                      src: "/img/icons/make-editable.png",
                      width: "30",
                      height: "30",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "card-text" }, [
                  _vm._v("\n            Make Editable\n          "),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.makeEditableV2UiEnabled
            ? _c(
                "div",
                {
                  staticClass:
                    "card text-center h-100 hover-card make-editable-v2",
                  attrs: { "data-id": _vm.selectedInstance.id },
                },
                [
                  _c("div", { staticClass: "card-body" }, [
                    _c("h5", { staticClass: "card-title" }, [
                      _c("img", {
                        attrs: {
                          src: "/img/icons/make-editable.png",
                          width: "30",
                          height: "30",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "card-text" }, [
                      _vm._v("\n            Make Editable V2\n          "),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card text-center h-100 hover-card extract-claims" },
            [
              _c("div", { staticClass: "card-body" }, [
                _c(
                  "h5",
                  { staticClass: "card-title" },
                  [
                    _c("b-icon", {
                      staticClass: "icon-size",
                      attrs: { icon: "input-cursor-text", scale: "1.5" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "card-text" }, [
                  _vm._v("\n            Extract Claims\n          "),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "b-tab",
        { attrs: { title: "Add Fields" } },
        [
          _c("div", { staticClass: "content-module-cards mt-3" }, [
            _c(
              "div",
              {
                staticClass: "card text-center h-100 hover-card",
                on: {
                  click: function ($event) {
                    return _vm.addAdditionalField("Multi Line Text")
                  },
                },
              },
              [
                _c("div", { staticClass: "card-body" }, [
                  _c(
                    "h5",
                    { staticClass: "card-title" },
                    [
                      _c("b-icon", {
                        staticClass: "icon-size",
                        attrs: { icon: "input-cursor-text", scale: "1.5" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "card-text" }, [
                    _vm._v("\n            Text\n          "),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "card text-center h-100 hover-card",
                on: {
                  click: function ($event) {
                    return _vm.addAdditionalField("Rectangle")
                  },
                },
              },
              [
                _c("div", { staticClass: "card-body" }, [
                  _c(
                    "h5",
                    { staticClass: "card-title" },
                    [
                      _c("b-icon", {
                        staticClass: "icon-size",
                        attrs: { icon: "square", scale: "1.5" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "card-text" }, [
                    _vm._v("\n            Rectangle\n          "),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "card text-center h-100 hover-card",
                on: {
                  click: function ($event) {
                    return _vm.addAdditionalField("Circle")
                  },
                },
              },
              [
                _c("div", { staticClass: "card-body" }, [
                  _c(
                    "h5",
                    { staticClass: "card-title" },
                    [
                      _c("b-icon", {
                        staticClass: "icon-size",
                        attrs: { icon: "circle", scale: "1.5" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "card-text" }, [
                    _vm._v("\n            Circle\n          "),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "card text-center h-100 hover-card",
                on: {
                  click: function ($event) {
                    return _vm.addAdditionalField("Safe Zone")
                  },
                },
              },
              [
                _c("div", { staticClass: "card-body" }, [
                  _c(
                    "h5",
                    { staticClass: "card-title" },
                    [
                      _c("b-icon", {
                        staticClass: "icon-size",
                        attrs: { icon: "x-square", scale: "1.5" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "card-text" }, [
                    _vm._v("\n            Safe Zone\n          "),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "card text-center h-100 hover-card",
                on: {
                  click: function ($event) {
                    return _vm.addAdditionalField("Icons")
                  },
                },
              },
              [
                _c("div", { staticClass: "card-body" }, [
                  _c(
                    "h5",
                    { staticClass: "card-title" },
                    [
                      _c("b-icon", {
                        staticClass: "icon-size",
                        attrs: { icon: "file-earmark-image", scale: "1.5" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "card-text" }, [
                    _vm._v("\n            Icons\n          "),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "card text-center h-100 hover-card",
                on: {
                  click: function ($event) {
                    return _vm.addAdditionalField("Line")
                  },
                },
              },
              [
                _c("div", { staticClass: "card-body" }, [
                  _c(
                    "h5",
                    { staticClass: "card-title" },
                    [
                      _c("b-icon", {
                        staticClass: "icon-size",
                        attrs: { icon: "border-width", scale: "1.5" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "card-text" }, [
                    _vm._v("\n            Line\n          "),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "card text-center h-100 hover-card",
                on: {
                  click: function ($event) {
                    return _vm.addAdditionalField("Table")
                  },
                },
              },
              [
                _c("div", { staticClass: "card-body" }, [
                  _c(
                    "h5",
                    { staticClass: "card-title" },
                    [
                      _c("b-icon", {
                        staticClass: "icon-size",
                        attrs: { icon: "table", scale: "1.5" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "card-text" }, [
                    _vm._v("\n            Table\n          "),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "card text-center h-100 hover-card",
                on: {
                  click: function ($event) {
                    return _vm.addAdditionalField("Cut Line")
                  },
                },
              },
              [
                _c("div", { staticClass: "card-body" }, [
                  _c(
                    "h5",
                    { staticClass: "card-title" },
                    [
                      _c("b-icon", {
                        staticClass: "icon-size",
                        attrs: { icon: "scissors", scale: "1.5" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "card-text" }, [
                    _vm._v("\n            Cut Line\n          "),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "card text-center h-100 hover-card",
                on: {
                  click: function ($event) {
                    return _vm.addCalloutField("Rectangle")
                  },
                },
              },
              [
                _c("div", { staticClass: "card-body" }, [
                  _c("h5", { staticClass: "card-title position-relative" }, [
                    _c(
                      "div",
                      { staticClass: "position-relative text-center" },
                      [
                        _c("div", { staticClass: "t-icon-contaner" }, [
                          _c("strong", { staticClass: "t-icon" }, [
                            _vm._v("T"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("b-icon", {
                          staticClass: "icon-size",
                          attrs: { icon: "input-cursor-text", scale: "1.5" },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "card-text" }, [
                    _vm._v("\n            Callout\n          "),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "card text-center h-100 hover-card",
                on: { click: _vm.addProductDimensionsField },
              },
              [
                _c("div", { staticClass: "card-body" }, [
                  _c("h5", { staticClass: "card-title position-relative" }, [
                    _c(
                      "div",
                      { staticClass: "position-relative text-center" },
                      [
                        _c("div", { staticClass: "t-icon-contaner" }, [
                          _c("strong", { staticClass: "t-icon" }, [
                            _vm._v("T"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("b-icon", {
                          staticClass: "icon-size",
                          attrs: { icon: "aspect-ratio", scale: "1.5" },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "card-text" }, [
                    _vm._v("\n            Product Dimensions\n          "),
                  ]),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("IconsSettingsModal", { ref: "iconsSettingsModal" }),
          _vm._v(" "),
          _c("SimpleTableBuilderModal"),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "my-3" },
        [
          _c("b-input", {
            staticClass: "form-control mb-2",
            attrs: { type: "text", placeholder: "Field name" },
            model: {
              value: _vm.fieldName,
              callback: function ($$v) {
                _vm.fieldName = $$v
              },
              expression: "fieldName",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "position-fixed apply-to-section" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex align-items-center justify-content-between",
              },
              [
                _c(
                  "div",
                  [
                    _c("span", [_vm._v("Add to")]),
                    _vm._v(" "),
                    _c("PreviewsDropdown", {
                      model: {
                        value: _vm.selectedInstancesIds,
                        callback: function ($$v) {
                          _vm.selectedInstancesIds = $$v
                        },
                        expression: "selectedInstancesIds",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }